
import { useRef } from 'react';
import FreeProxyPopup, { FreeProxyPopupRef } from '@/components/FreeProxyPopup';
import SEOMetadata from '@/components/SEOMetadata';
import BangladeshHeader from '@/components/bangladesh/BangladeshHeader';
import ServicesGrid from '@/components/bangladesh/ServicesGrid';
import EthicalUseCases from '@/components/bangladesh/EthicalUseCases';
import BangladeshFooter from '@/components/bangladesh/BangladeshFooter';

const BangladeshSplash = () => {
  const popupRef = useRef<FreeProxyPopupRef>(null);

  const handleGetFreeAccess = () => {
    popupRef.current?.openForm();
  };

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Service",
    "name": "Bangladesh Internet Services",
    "provider": {
      "@type": "Organization",
      "name": "NEXX TELECOM"
    },
    "description": "Specialized internet services and proxy solutions for users in Bangladesh. Secure, reliable connectivity solutions.",
    "serviceType": "Internet Connectivity Services",
    "areaServed": "Bangladesh"
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 via-white to-red-50 relative overflow-hidden">
      <SEOMetadata
        title="Bangladesh Internet Services | Secure Connectivity | NEXX"
        description="Specialized internet services and secure connectivity solutions for users in Bangladesh. Built for local needs with global expertise."
        keywords="Bangladesh internet, Bangladesh proxy, secure connectivity Bangladesh, internet services BD"
        canonical="https://nexx.net/bangladesh"
        structuredData={structuredData}
      />
      {/* Bangladesh Flag Colors Background Elements */}
      <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-green-600 via-green-600 to-red-600"></div>
      
      {/* Animated Background Elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-20 left-10 w-32 h-32 bg-green-500/10 rounded-full animate-pulse"></div>
        <div className="absolute top-40 right-20 w-24 h-24 bg-red-500/10 rounded-lg rotate-45 animate-bounce" style={{ animationDuration: '3s' }}></div>
        <div className="absolute bottom-40 left-20 w-20 h-20 bg-green-500/10 rounded-full animate-ping" style={{ animationDelay: '1s', animationDuration: '4s' }}></div>
      </div>

      <div className="relative z-10 flex flex-col min-h-screen">
        <div className="max-w-7xl mx-auto px-4 py-8 flex-grow">
          <BangladeshHeader />
          <ServicesGrid onGetFreeAccess={handleGetFreeAccess} />
          
          {/* Trust Message */}
          <div className="text-center mb-4">
            <div className="inline-flex items-center px-6 py-2 bg-gradient-to-r from-green-600 to-red-600 text-white rounded-full shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:scale-105">
              <span className="text-lg animate-pulse">👉</span>
              <span className="ml-3 font-bold">Built for users in Bangladesh. No hassle. No risk.</span>
            </div>
          </div>

          <EthicalUseCases />
        </div>

        <BangladeshFooter />
      </div>

      {/* Popup Component */}
      <FreeProxyPopup ref={popupRef} />
    </div>
  );
};

export default BangladeshSplash;
